<template>
  <IQOS systemDependency="inside" :enabled="is_active" :title="$t('inside.services.title')">
    <div class="services-editor mt-16" v-if="is_active">
      <div
        class="single-service mt-16"
        v-for="(item, index) in call_services"
        :key="index"
      >
        <BaseInput
          class="service-input"
          :placeholder="$t('inside.services.service_name')"
          v-model="item.name"
          maxlength="64"
          fullWidth
          :readonly="!editing"
          @blur="onEditFinish"
        />
        <BaseButton @click="removeService(index)"  icon="trash" class="ml-8"  color="red-4" size="md" variant="secondary" />
      </div>
    </div>

    <div class="iqos-flex-right">
    <BaseButton
      size="md"
      icon="plus"
      variant="secondary"
      color="v1-grey-3"
      class="mt-16"
      @click="addService"
      v-if="is_active && call_services.length < 30"
      >{{ $t("inside.services.add") }}</BaseButton
    >
    </div>

    <p class="iqos-comment qrw-paragraph-md mt-16" v-if="!is_active">
      {{ $t("inside.services.input_hint") }}
    </p>

    <template #actions><IQOSToggle v-model="is_active" /></template>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      call_services: [],
      editing: true,

      is_active: false,
    };
  },
  watch: {
    is_active() {
      if (!this.is_active) {
        this.onEditFinish();
      }
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.resetValues();
    },
    onEditFinish() {
      this.$store.commit("setCafeCallServices", this.call_services.slice());
      this.$store.dispatch("saveCafe");

      // this.editing = false;

      this.$store.dispatch("auditlog/write", {
        type: "inside_services",
        payload: {
          count: this.call_services.length,
        },
      });
    },
    resetValues() {
      this.call_services = (this.$store.state.cafe.call_services || []).slice();

      if (this.call_services.length) {
        this.is_active = true;
      }
    },
    removeService(index) {
      this.call_services.splice(index, 1);

      this.onEditFinish();

      if (!this.call_services.length) {
        this.is_active = false;
      }
    },
    addService() {
      this.call_services.push({
        name: null,
      });
    },
  },
  mounted() {
    this.resetValues();
  },

  components: {
  },
};
</script>

<style scoped>
.single-service {
  display: flex;
  align-items: center;
}

.single-service:first-of-type {
  margin-top: 0;
}

.service-input {
  width: 95%;
}

.delete-button {
  height: 3.88vh;
  margin-left: 1.2vh;
  width: 3.88vh;
  cursor: pointer;
}
.iqos-small-delete-button.delete-button div.image {
  width: 2.111vh !important;
  height: 2.111vh !important;
}
</style>
